import apiHeader from '@/helpers/apiHeader';

const faqService = {
  list(params) {
    return apiHeader.get('faq/faq-list', { params });
  },
  userGuide() {
    return apiHeader.get('faq/user-guide');
  },
  detail(id) {
    return apiHeader.get('faq/faq-list/' + id);
  },
  create(params) {
    return apiHeader.post('faq/faq-list', params);
  },
  patch(id, params) {
    return apiHeader.patch('faq/faq-list/' + id, params);
  },
  delete(id) {
    return apiHeader.delete('faq/faq-list/' + id);
  }
};

export default faqService;
